/* global ICAL */
(function(angular) {
  'use strict';

  angular.module('esn.ical', [])
    .constant('ICAL', ICAL);
})(angular);
